import React from 'react';
import { Box, Container, Typography, Card, CardContent, Avatar, Rating, useTheme, useMediaQuery } from '@mui/material';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const testimonials = [
  {
    name: 'Anjali Sharma',
    city: 'Pune',
    rating: 5,
    text: 'The product key for Windows 11 was sent instantly. Followed the guide and it activated in under 2 minutes. Excellent service and support!',
  },
  {
    name: 'Vikram Malhotra',
    city: 'Mumbai',
    rating: 4.8,
    text: 'Highly impressed with the genuine MS Office 2024 license. It links directly to my official Microsoft account. Highly recommended.',
  },
  {
    name: 'Priya Iyer',
    city: 'Chennai',
    rating: 5,
    text: 'Purchased Windows Server 2025 keys for our small business. Clean installation, no issues, and outstanding customer service.',
  },
];

const Testimonials = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    responsive: [
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  };

  return (
    <Box sx={{ py: isMobile ? 4 : 8, background: 'linear-gradient(160deg, #D6EFFF 0%, #D6EFFF 50%, #D6EFFF 100%)', overflow: 'hidden' }}>
      <Container maxWidth="lg">
        <Typography
          variant="h3"
          align="center"
          gutterBottom
          sx={{
            mb: isMobile ? 4 : 6,
            fontSize: isMobile ? '2.2rem' : '3rem',
            fontWeight: 800
          }}
        >
          Trusted by 50,000+ Customers
        </Typography>

        <Box sx={{ mx: -2 }}>
          <Slider {...settings}>
            {testimonials.map((t, index) => (
              <Box key={index} sx={{ px: 2, pb: 4 }}>
                <Card sx={{ height: '100%', borderRadius: 0, boxShadow: 'none', border: '1px solid #EAEAEA' }}>
                  <CardContent sx={{ p: 4 }}>
                    <Rating value={t.rating} precision={0.1} readOnly size="small" sx={{ mb: 2 }} />
                    <Typography variant="body1" sx={{ fontStyle: 'italic', mb: 3, minHeight: '80px' }}>
                      "{t.text}"
                    </Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      <Avatar sx={{ bgcolor: 'secondary.main' }}>{t.name[0]}</Avatar>
                      <Box>
                        <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                          {t.name}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          {t.city}
                        </Typography>
                      </Box>
                    </Box>
                  </CardContent>
                </Card>
              </Box>
            ))}
          </Slider>
        </Box>
      </Container>
    </Box>
  );
};

export default Testimonials;
